import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Divider,
  Space,
  Typography,
  Button,
  Checkbox,
  Form,
  Input,
  notification,
} from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import logo from '../../../images/sleasing-logo-primary 1.svg';

const { Title } = Typography;

const Login = ({ actions }) => {
  useEffect(() => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('spremiumAuthToken');
  }, []);

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, msg) => {
    api[type]({
      message: msg,
      style: {
        width: 300,
      },
    });
  };

  const onFinish = values => {
    const userData = {
      username: values.ime,
      password: values.lozinka,
      rememberMe: values.remember,
    };

    actions.loginUser(userData);
  };
  const onFinishFailed = errorInfo => {
    // openNotificationWithIcon("error", "Neuspjesno");
  };

  return (
    <div className="flex h-screen bg-dark-blue">
      {contextHolder}
      <div className="bg-login-white w-[450px] h-[500px] m-auto rounded-md shrink-0">
        <img className="mt-16 m-auto" src={logo} />
        <Title className="text-center text-sm text-dark-blue mt-3">
          LEASING KALKULATOR
        </Title>
        <Form
          className="px-11 "
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Title
            className="w-fit font-normal text-light-blue-login border-b-2 border-light-blue-login"
            level={5}
          >
            Login
          </Title>
          <Divider className="mt-0" />
          <Form.Item
            name="ime"
            rules={[
              {
                required: true,
                message: 'Korisničko ime ne može biti prazno!',
              },
            ]}
          >
            <Input
              prefix={<UserOutlined className="text-light-blue-login " />}
              className="h-10 text-[16px]"
              placeholder="korisničko ime"
            />
          </Form.Item>

          <Form.Item
            name="lozinka"
            rules={[
              {
                required: true,
                message: 'Loznika ne može biti prazno!',
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="text-light-blue-login" />}
              className="h-10 text-[16px]"
              placeholder="lozinka"
              visibilityToggle={false}
            />
          </Form.Item>

          <Space className="flex justify-between">
            <Form.Item name="remember" valuePropName="checked">
              <Checkbox className="text-black">Zapamti me</Checkbox>
            </Form.Item>

            <Form.Item>
              <Link className="text-light-blue-login " to={'/reset-password'}>
                Promjeni lozinku
              </Link>
            </Form.Item>
          </Space>

          <Form.Item>
            <Button
              className="bg-light-blue-login w-fit text-white text-[16px] font-bold h-10"
              htmlType="submit"
            >
              PRIJAVI SE
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Login;
